import { useFlags } from 'launchdarkly-react-client-sdk';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Dispatch } from 'src/config/rootStore';

import { MappedAnswers } from '../models/assessments';
import { getWho5Questions, getWho5Score } from '../selectors/assessmentsSelectors';
import { Assessment } from './Assessment';

interface Props {
    onSubmit: (newScore: number, oldScore: number) => void;
    assessmentFlowUuid: string;
    currentWeek?: number;
    showTopControls?: boolean;
    hideEmploymentHealthQuestions?: boolean;
}

export const Who5Assessment: React.FC<Props> = ({
    onSubmit,
    assessmentFlowUuid,
    currentWeek,
    showTopControls,
    hideEmploymentHealthQuestions = false,
}) => {
    const dispatch: Dispatch = useDispatch();

    const flags = useFlags();

    const who5Score = useSelector(getWho5Score);
    const questions = useSelector(state =>
        getWho5Questions(state, !flags.wellbeingOnlyWho5 && !hideEmploymentHealthQuestions),
    );

    if (!questions.length) {
        return null;
    }

    const handleSubmit = async (answers: MappedAnswers) => {
        // required only for legacy programs
        if (currentWeek) {
            await dispatch.assessments.submitLegacyWho5Assessment({
                pillarWeek: currentWeek,
                answers,
            });
        }

        const oldScore = who5Score;

        const response = await dispatch.assessments.submitAssessments({
            answers,
            assessmentFlowUuid,
        });

        onSubmit(response?.who5, oldScore);
    };

    return (
        <Assessment
            onSubmit={handleSubmit}
            questions={questions}
            showTopControls={showTopControls}
            hideProgressBar
        />
    );
};
